import { render, staticRenderFns } from "./transformList.vue?vue&type=template&id=1f75fa15&scoped=true"
import script from "./transformList.vue?vue&type=script&lang=js"
export * from "./transformList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f75fa15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f75fa15')) {
      api.createRecord('1f75fa15', component.options)
    } else {
      api.reload('1f75fa15', component.options)
    }
    module.hot.accept("./transformList.vue?vue&type=template&id=1f75fa15&scoped=true", function () {
      api.rerender('1f75fa15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchase/components/transformList.vue"
export default component.exports